(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verification"] && !Shopify.designMode) return;
  try {
    
(() => {
  const gate = document.querySelector('[data-lg-age-gate]');
  if (!gate || gate.dataset.initialized) return;
  gate.dataset.initialized = 'true';
  const key = gate.dataset.cookieKey;
  const ttl = 7 * 86400000;
  const preview = new URLSearchParams(location.search).get('age_gate') === 'preview';
  const question = gate.querySelector('[data-lg-age-question]');
  const denied = gate.querySelector('[data-lg-age-denied]');
  const yes = gate.querySelector('[data-lg-age-yes]');
  const no = gate.querySelector('[data-lg-age-no]');
  let deadline = 0;
  let expiryTimer;
  let previousFocus;

  function read() {
    try {
      const raw = document.cookie.split('; ').find(value => value.startsWith(key + '='));
      if (!raw) return null;
      const record = JSON.parse(decodeURIComponent(raw.slice(key.length + 1)));
      const now = Date.now();
      if (!['yes', 'no'].includes(record.answer) || !Number.isFinite(record.expires) || record.expires <= now || record.expires > now + ttl + 60000) return null;
      return record;
    } catch { return null; }
  }

  function remember(answer) {
    const record = {answer, expires: Date.now() + ttl};
    deadline = record.expires;
    if (!preview) {
      try {
        document.cookie = key + '=' + encodeURIComponent(JSON.stringify(record)) + '; Max-Age=604800; Path=/; SameSite=Lax; Secure';
      } catch {}
    }
    return record;
  }

  function openGate(answer) {
    previousFocus = document.activeElement;
    const rejected = answer === 'no';
    question.hidden = rejected;
    denied.hidden = !rejected;
    gate.setAttribute('aria-labelledby', rejected ? 'lg-age-denied' : 'lg-age-question');
    document.documentElement.classList.add('lg-age-locked');
    if (!gate.open) gate.showModal();
    if (rejected) denied.querySelector('a').focus();
    else yes.focus();
  }

  function allow() {
    gate.close();
    document.documentElement.classList.remove('lg-age-locked');
    if (previousFocus && previousFocus.isConnected && previousFocus !== document.body) previousFocus.focus();
    document.dispatchEvent(new CustomEvent('lg:ageAccepted'));
    clearTimeout(expiryTimer);
    if (deadline) expiryTimer = setTimeout(checkExpiry, Math.max(1, deadline - Date.now()));
  }

  function checkExpiry() {
    if (preview || gate.open) return;
    if (deadline && Date.now() >= deadline) {
      deadline = 0;
      openGate();
    }
  }

  gate.addEventListener('cancel', event => event.preventDefault());
  yes.addEventListener('click', () => {
    remember('yes');
    allow();
  });
  no.addEventListener('click', () => {
    remember('no');
    openGate('no');
  });
  window.addEventListener('pageshow', checkExpiry);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) checkExpiry();
  });
  const saved = preview ? null : read();
  if (saved && saved.answer === 'yes') {
    deadline = saved.expires;
    expiryTimer = setTimeout(checkExpiry, Math.max(1, deadline - Date.now()));
  } else {
    openGate(saved ? saved.answer : null);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
